import ModuleBase, { ViewLayer, moduleTypeNames } from "./mvvm/module_base";
import ViewBase from "./mvvm/view_base";
import ModelBase from './mvvm/model_base';
import Dialog from "../../pacakge/public/module/dialog/dialog";
import GameUtil from "../../utility/game_util";
import LanguageManager from "../../manager/language_manager";
import AppData from "../../pacakge/public/const/app_data";
import ModelData from "../../pacakge/public/model_data";
import ChatInfo from "../../pacakge/table/module/tablechat/chatinfo";
import OhterChatInfo from "../../pacakge/table/module/tablechat/ohter_chat_info";
import SceneManager from "../../manager/scene_manager";
import { GameManager } from "../../manager/game_manager";
import { allwaysInMemory } from "../../config/module_config";
import ClubUserInfo from "../../pacakge/club/clubUserInfo/club_userInfo";
import PlayerInfoSetting from "../../pacakge/hall/module/playerInfoSetting/player_info_setting";


const { ccclass, property } = cc._decorator;



@ccclass
export default class ModuleManager extends cc.Component {

    //预加载的资源，一个一个加载
    _asynPath: string[] = [
        "package/hall/module/hall/hall_hall",
        "package/hall/module/base_bg/base_bg",
        "package/hall/module/base_bg/base_bg_mid",
        "package/hall/module/base_bg/base_bg_mini",
        "package/table/game_morepanel",
    ]


    _visitAccoutNoAccessModule: string[] = [
        "FriendModule",
        "Chat",
        "ClubList",
        "ClubBank",
        "ClubPromotion",
        "ClubNotice",
        "ClubUserInfo",
        "ClubGame",
        "Shop",
        "QuickBuy"
    ]

    _asynLoadResCount: number = 0


    static instance: ModuleManager;

    private _modules: any = {}

    private _removeModules: any = {}

    /**
     * 等待销毁的module
     */
    private _watingReleases: any = {}

    @property(cc.Node)
    test: cc.Node = null;

    @property(cc.Node)
    low: cc.Node = null;

    @property(cc.Node)
    middle: cc.Node = null;

    @property(cc.Node)
    high: cc.Node = null;

    @property(cc.Node)
    highest: cc.Node = null;

    @property(cc.Node)
    asset: cc.Node = null;

    onLoad() {
        ModuleManager.instance = this;
        this.test.active = false
    }

    registModule(name: string, T) {
        moduleTypeNames[name] = T
    }

    public addModule<T extends ModuleBase<ViewBase, ModelBase>>(T, moduleName: string, intentData?: any, onFinishLoad?: (module: ModuleBase<ViewBase, ModelBase>, state: boolean) => void): T {
        let tName = moduleName;
        let module: T = this._modules[tName];
        if (module == null) {
            let newNode = new cc.Node()
            newNode.name = tName
            let widget = newNode.addComponent(cc.Widget)
            widget.isAlignTop = true;
            widget.isAlignBottom = true;
            widget.isAlignLeft = true;
            widget.isAlignRight = true;
            widget.alignMode = cc.Widget.AlignMode.ONCE

            module = newNode.addComponent(T)
            if (module == null) {
                cc.warn("addModule失败：" + tName)
                return null
            }
            module.moduleType = T
            module.moduleName = tName
            switch (module.layer) {
                case ViewLayer.Low:
                    newNode.width = this.low.width
                    this.low.addChild(newNode)
                    break;
                case ViewLayer.Mid:
                    newNode.width = this.middle.width
                    this.middle.addChild(newNode)
                    break;
                case ViewLayer.High:
                    newNode.width = this.high.width
                    this.high.addChild(newNode)
                    break;
                case ViewLayer.Highest:
                    newNode.width = this.highest.width;
                    this.highest.addChild(newNode);
                    break;
                default:
                    newNode.width = this.low.width
                    this.low.addChild(newNode)
                    break;
            }
            this._modules[tName] = module;
            module.node.setSiblingIndex(module.node.parent.childrenCount - 1)
            module.init(intentData, onFinishLoad);
        }
        return module
    }

    //跳转到某个模块，会把其他模块都隐藏
    goToModule<T>(T, intentData?: any, completeCallback?: Function) {
        let self = this
        let moduleName = T.moduleClassName
        this.showModule(T, intentData, function () {
            self.hideAllModuleS(moduleName, true)
            if (completeCallback) {
                completeCallback()
            }
        })
    }
    showEmojiModule(playerId: number, moudleName: string, gold?: number, chip?: number) {
        let intentData: any = []
        intentData["playerId"] = playerId
        intentData["moduleName"] = moudleName
        intentData['gold'] = gold
        intentData['chip'] = chip

        if (ModelData.instance.tableCommonData.isClubTable) {
            this.showModule(ClubUserInfo, intentData)
        } else {
            if (playerId == ModelData.instance.roleData.id) {
                this.showModule(PlayerInfoSetting)
            }
            else {
                this.showModule(OhterChatInfo, intentData)
            }
        }


    }


    showModule<T extends ModuleBase<ViewBase, ModelBase>>(T, intentData?: any, completeCallback?: (module: ModuleBase<ViewBase, ModelBase>, state: boolean) => void): T {
        let moduleName = T.moduleClassName
        if (!moduleName) {
            cc.error("请在模块Module类中添加@moduleClassName('模块的类名')装饰器", T)
            return
        }
        let module: any = this.showModuleName(moduleName, intentData, completeCallback);
        return module
    }

    showModuleName(moduleName: string, intentData?: any, completeCallback?: (module: ModuleBase<ViewBase, ModelBase>, state: boolean) => void) {
        // if (this.isNoAccessShowModule(moduleName, true)) {
        //     return null
        // }

        cc.warn("showModuleName：" + moduleName)
        let module: ModuleBase<ViewBase, ModelBase> = this._modules[moduleName];
        if (module != null && !module.isInited) {
            module.destroyModule()
            this._modules[moduleName] = null
            module = null
        }

        if (module == null) {
            if (moduleTypeNames[moduleName]) {
                let T = moduleTypeNames[moduleName]
                module = this.addModule(T, moduleName, intentData, completeCallback)
                module.inLoading = true;

            } else {
                cc.error("showModuleName没找到对应的class：", moduleName)
            }

        } else {

            module.inLoading = true;
            module.node.setSiblingIndex(module.node.parent.childrenCount - 1)
            module.moduleBaseShow(intentData, completeCallback)
        }
        return module
    }

    isNoAccessShowModule(moduleName, toastBindSocialAccount?, cancelCallback?) {
        if (AppData.startCheckGame) {
            if (cancelCallback) {
                cancelCallback()
            }
            return false
        }
        if ((ModelData.instance.needBindSocialAccount || ModelData.instance.loginWithVisitors) && (!moduleName || this._visitAccoutNoAccessModule.includes(moduleName)) && !AppData.testMode) {
            if (toastBindSocialAccount) {
                ModuleManager.instance.showDialogConfirmCancel(LanguageManager.t("login_visitor_need_bind_social_account"), () => {
                    ModuleManager.instance.showModuleName("Activity", { tag: 'activity', subTag: 'bind', onlyOne: true })
                });  //, cancelCallback
            }
            return true
        }
        if (cancelCallback) {
            cancelCallback()
        }
        return false
    }



    toastLong(text: string) {
        let data = { text: text, long: true }
        this.showModuleName("Toast", data)
        return module
    }

    toast(text: string) {
        this.showModuleName("Toast", text)
        return module
    }

    toast500error(error: IHttpErrorData) {
        if (error && error.msg) {
            if (error.detail && AppData.testMode) {
                ModuleManager.instance.toast(error.msg + "(" + error.detail + ")")
            } else {
                ModuleManager.instance.toast(error.msg)
            }
        }
    }

    toastKey(key: string) {
        this.showModuleName("Toast", LanguageManager.t(key, true))
        return module
    }

    showDialogConfirm(text: string, confirmBtnCallback: Function, title?: string, clickButtonConfirmNotHideView?) {
        ModuleManager.instance.showModule<Dialog>(Dialog).show_center_button(title, text, confirmBtnCallback, clickButtonConfirmNotHideView)
    }

    showDialogConfirmCancel(text: string, confirmBtnCallback: Function, cancelBtnCallback?: Function, title?: string, clickButtonConfirmNotHideView?) {
        ModuleManager.instance.showModule<Dialog>(Dialog).show_common(title, text, confirmBtnCallback, cancelBtnCallback, clickButtonConfirmNotHideView)
    }



    moduleHasActive(moduleName: string) {
        let module: ModuleBase<ViewBase, ModelBase> = this._modules[moduleName];
        if (module) {
            return module.nodeIsActive
        }

        return false;
    }

    moduleInLoading(moduleName: string) {
        let module: ModuleBase<ViewBase, ModelBase> = this._modules[moduleName];
        if (module) {
            return module.inLoading;
        }

        return false;
    }

    moduleLayerType(moduleName: string) {
        let module: ModuleBase<ViewBase, ModelBase> = this._modules[moduleName];
        if (module) {
            return module.layer
        }
    }


    setModuleActive(moduleName: string, needAdd) {
        let module: ModuleBase<ViewBase, ModelBase> = this._modules[moduleName];
        if (module) {
            module.setActive()
        } else {
            if (needAdd) {
                this.showModuleName(moduleName)
            }
        }
    }

    getModule(moduleName: string) {
        let module = this._modules[moduleName]
        return module
    }


    hideModule(moduleName: string) {
        let module: ModuleBase<ViewBase, ModelBase> = this._modules[moduleName];
        if (module) {
            //cc.warn("hideModule：", moduleName)
            module.hide()
        }
    }

    hideAllModuleS(exclusiveMoudleName?: string, incluePublicPackage?: boolean) {
        for (let key in this._modules) {
            let module: ModuleBase<ViewBase, ModelBase> = this._modules[key]
            if (module == null || (exclusiveMoudleName && module.moduleName && exclusiveMoudleName == module.moduleName)) {
                continue;
            }
            if (!incluePublicPackage) {
                if (module.package != "public") {
                    module.hide()
                }
            } else {
                cc.warn("hideModule：", module.moduleName)
                module.hide()
            }
        }
    }

    hideAllModule(except?: any) {
        let exceptList = ['Toast', 'NetPrompt', 'WebFullScreen', 'LoadingModule']
        if (except) {
            if (except instanceof Array) {
                for (let i = 0; i < except.length; i++) {
                    exceptList.push(except[i]);
                }
            } else if (typeof (except) == 'string') {
                exceptList.push(except);
            }
        }
        for (const name in this._modules) {
            let needHide = true
            for (let i = 0; i < exceptList.length; i++) {
                if (name == exceptList[i]) {
                    needHide = false;
                    break;
                }
            }
            if (needHide) {
                this.hideModule(name);
            }
        }
    }

    //移除module，但是不销毁
    removeModule(moduleName: string, release?: boolean) {
        let module: ModuleBase<ViewBase, ModelBase> = this._modules[moduleName];
        if (module) {
            cc.warn("removeModule：", moduleName)
            this._modules[moduleName] = null
            this._removeModules[moduleName] = module
        }
        return module
    }

    destroyRemoveModule(moduleName: string, release: boolean = false) {
        let module: ModuleBase<ViewBase, ModelBase> = this._removeModules[moduleName];
        if (module) {
            cc.warn("destroyRemoveModule：", moduleName, module.showId)
            module.destroyModule(release)
            this._removeModules[moduleName] = null
        }
        return module
    }

    destroyModule(moduleName: string, release: boolean = true) {
        let module: ModuleBase<ViewBase, ModelBase> = this._modules[moduleName];
        if (module) {
            cc.warn("destroyModule：", moduleName, module.showId)
            module.destroyModule(release)
            this._modules[moduleName] = null
            // if (!release) {
            //     this._watingReleases[moduleName] = module.windowPrefabResPath;
            // }
        }

        // if (release) {                   
        //     let resPath = this._watingReleases[moduleName];
        //     if (resPath) {
        //         cc.warn(" releaseWatingModule " , moduleName); 
        //         resLoader.releaseRes(resPath);  
        //     }                       
        // }        
    }


    destroyAllModule(except?: any, release: boolean = false) {

        let exceptList = except ? allwaysInMemory.concat(except) : allwaysInMemory;
        for (const name in this._modules) {
            let needDestory = true;
            for (let index = 0; index < exceptList.length; index++) {
                const element = exceptList[index];
                if (element == name) {
                    needDestory = false;
                    break;
                }
            }
            if (needDestory) {
                this.destroyModule(name, release);
            }

        }

        //this.hideModule("NetPrompt")
        this.hideModule("Dialog")
    }

    //销毁整个package
    destroyPackage(packageName: string) {
        let needDestroyModuleName
        for (const key in this._modules) {
            let module = this._modules[key]
            if (module.packageName == packageName) {
                needDestroyModuleName.push(key)
            }
        }

        if (needDestroyModuleName) {
            for (const moduleName in needDestroyModuleName) {
                this.destroyModule(moduleName)
            }
        }
    }

    //隐藏package下的所有模块
    hidePackage(packageName: string) {
        for (const key in this._modules) {
            let module = this._modules[key]
            if (module.packageName == packageName) {
                module.hide()
            }
        }
    }

    playAnim(open: boolean, target: cc.Node, mask?: cc.Node, callback?: Function) {
        if (open) {
            target.active = true
            target.scale = 0.9
            let action1 = cc.scaleTo(0.2, 1)
            action1.easing(cc.easeBackOut())
            target.runAction(action1)
            if (mask) {
                mask.active = true
                let action2 = cc.fadeTo(0.3, 190)
                mask.runAction(action2)
            }

            this.scheduleOnce(() => {
                if (callback) {
                    callback()
                }
            }, 0.1)
        } else {
            //关闭缩放动画
            // target.scale = 1
            // let action1 = cc.scaleTo(0.3, 0.01)
            // action1.easing(cc.easeBackIn())
            // target.runAction(action1)
            // if (mask) {
            //     mask.active = true
            //     let action2 = cc.fadeTo(0.3, 0)
            //     mask.runAction(action2)
            // }
            // this.scheduleOnce(() => {
            //     if (callback) {
            //         callback()
            //     } else {
            //         if (target && target.isValid) {
            //             target.active = false
            //         }
            //     }
            // }, 0.3)

            //直接关闭，不播放缩放动画
            if (target && target.isValid) {
                target.active = false
            }

            if (mask) {
                mask.active = false
            }

            if (callback) {
                callback()
            }
        }
    }

    addPreloadResUrl(resUrl) {

    }

    preLoadRes(completeCallback?: Function, progressCallback?: Function) {
        let self = this
        if (self._asynLoadResCount < self._asynPath.length) {
            let path = self._asynPath[self._asynLoadResCount]
            GameUtil.loadRes(path, (error: Error, resource: any) => {
                ++self._asynLoadResCount;
                if (error) {
                    cc.error(error)
                } else {
                    cc.log("预加载资源成功：", path)
                }
                self.preLoadRes(completeCallback, progressCallback)
                if (progressCallback) {
                    progressCallback(self._asynLoadResCount, self._asynPath.length)
                }
            })
        } else {
            if (completeCallback) {
                completeCallback();
            }
        }
    }

    goToLoginScene() {
        SceneManager.gotoAuth()
    }

    init() {
        let needLoadResArray = ["package/hall/module/login/hall_login", "package/public/asset_holder"]
        GameUtil.loadResArray(needLoadResArray, (error: Error, resource: cc.Prefab[]) => {
            if (error) {
                //TODO:需要处理的异常
                GameManager.reboot()
            } else {
                cc.log("加载完成")
                resource.forEach(element => {
                    if (element.name == "asset_holder") {
                        ModuleManager.instance.asset.addChild(cc.instantiate(element));
                    }
                });
                ModuleManager.instance.showModuleName("LoginModule")
            }
        })
    }
}
